import React from "react";

export const CloseIcon: React.FC<{ className?: string }> = ({ className }) => (
    <svg
        className={className}
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M6.10156 23.0711L13.1726 16.0001L16.0011 18.8285L8.92999 25.8996L6.10156 23.0711Z"
            fill="currentColor"
        />
        <path
            d="M13.1726 16.0001L6.10156 8.92901L8.92999 6.10059L16.0011 13.1717L13.1726 16.0001Z"
            fill="currentColor"
        />
        <path
            d="M23.0721 25.8996L16.0011 18.8285L18.8295 16.0001L25.9006 23.0711L23.0721 25.8996Z"
            fill="currentColor"
        />
        <path
            d="M16.0011 13.1717L23.0721 6.10059L25.9006 8.92901L18.8295 16.0001L16.0011 13.1717Z"
            fill="currentColor"
        />
    </svg>
);
